<template>
  <div :data-app-theme="$store.getters.theme" id="app" :style="desktopStyle">
    <div v-if="showOverlay" class="preloader">
      <div class="iframe-container">
        <iframe
          src="https://cdn.lottielab.com/l/E3DY8AoVNAAXSi.html"
          class="preloader"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
    <!-- Black overlay at startup -->
    <TopNav />
    <div class="screen" id="screen" style="position: relative">
      <transition name="app-window">
      <portfolio
        id="portfolio"
        :class="{ fullscreen: $store.getters.isFullscreenPortfolio }"
        v-if="$store.getters.isShownPortfolio"
        style="position: absolute; left: 6vw"
        @click.native="focusPortfolio"
      />
      </transition>
      <transition name="app-window">
      <game
        id="game"
        :class="{ fullscreen: $store.getters.isFullscreenGame }"
        v-if="$store.getters.isShownGame"
        style="position: absolute; top: 2%; right: 5vw"
        @click.native="focusGame"
      />
      </transition>
      <transition name="app-window">
      <photo-editor
        id="photoeditor"
        :class="{ fullscreen: $store.getters.isFullscreenPhotoEditor }"
        v-if="$store.getters.isShownPhotoEditor"
        style="position: absolute; left: 5vw"
        @click.native="focusPhotoEditor"
      />
      </transition>
      <transition name="app-window">
      <photos-modal
        id="photos"
        :class="{ fullscreen: $store.getters.isFullscreenPhotos }"
        v-if="$store.getters.isShownPhotos"
        style="position: absolute; right: 0"
        @click.native="focusPhotos"
      />
      </transition>
      <transition name="app-window">
      <stickies
        id="stickies"
        :class="{ fullscreen: $store.getters.isFullscreenStickies }"
        v-if="$store.getters.isShownStickies"
        style="position: absolute; top: 5%; right: 4vw"
        @click.native="focusStickies"
      />
      </transition>
      <transition name="app-window">
      <mail
        id="mail"
        :class="{ fullscreen: $store.getters.isFullscreenMail }"
        v-if="$store.getters.isShownMail"
        style="position: absolute; top: 5%; right: 5vw"
        @click.native="focusMail"
      />
      </transition>
      <transition name="app-window">
      <bio
        id="bio"
        :class="{ fullscreen: $store.getters.isFullscreenBio }"
        v-if="$store.getters.isShownBio"
        style="position: absolute; top: 2%; left: 5vw"
        @click.native="focusBio"
      />
      </transition>
      <transition name="app-window">
      <simulator
        id="simulator"
        v-if="$store.getters.isShownSimulator"
        style="position: absolute; left: 25%"
        @click.native="focusSimulator"
      />
      </transition>
      <transition name="app-window">
      <Settings id="settings" v-if="$store.state.isShownSettings" @click.native="focusSettings" />
      </transition>
      <transition name="launchpad-fade" appear>
        <Launchpad
          v-show="$store.getters.isShownLaunchpad"
          class="launchpad-window"
        />
      </transition>
    </div>
    <navbar @toggle-launchpad="toggleLaunchpad" />
  </div>
</template>

<script>
import Settings from "./components/Settings.vue";
import { wallpaperImage } from "./config/wallpapers";
import Launchpad from "./components/Launchpad.vue";
import Portfolio from "./components/Portfolio.vue";
import Game from "./components/GameOne.vue";
import PhotoEditor from "./components/PhotoEditor.vue";
import Navbar from "./components/Navbar";
import TopNav from "./components/TopNav";
import PhotosModal from "./components/PhotosModal.vue";
import Stickies from "./components/Notepad.vue";
import Mail from "./components/Mail.vue";
import Bio from "./components/Bio.vue";
import Simulator from "./components/Simulator.vue";
import "./assets/global.css";

export default {
  name: "App",
  data: function () {
    return {
      showOverlay: true,
      startupTimers: [],
      screenWidth: window.innerWidth, // Track screen width
    };
  },
  components: {
    Settings,
    Launchpad,
    Portfolio,
    Game,
    PhotoEditor,
    PhotosModal,
    Navbar,
    TopNav,
    Stickies,
    Mail,
    Bio,
    Simulator,
  },
  methods: {
    focusSettings() { this.$store.commit("changeActiveWindow", "Settings"); this.$store.commit("zIndexIncrement", "settings"); },
    focusLaunchpad() {
      this.$store.commit("changeActiveWindow", "Launchpad");
      this.$store.commit("zIndexIncrement", "launchpad");
    },
    toggleLaunchpad() {
      this.$store.commit("toggleLaunchpad");
      this.$nextTick(() => {
        this.forceRepaint(); // Ensures transition applies properly
      });
    },
    forceRepaint() {
      const el = document.querySelector(".launchpad-window");
      if (el) {
        void el.offsetHeight; // Forces a browser reflow
      }
    },
    focusPhotos() {
      this.$store.commit("changeActiveWindow", "Photos");
      this.$store.commit("zIndexIncrement", "photos");
    },
    focusPortfolio() {
      this.$store.commit("changeActiveWindow", "Portfolio");
      this.$store.commit("zIndexIncrement", "portfolio");
    },
    focusGame() {
      this.$store.commit("changeActiveWindow", "Game");
      this.$store.commit("zIndexIncrement", "game");
    },
    focusPhotoEditor() {
      this.$store.commit("changeActiveWindow", "PhotoEditor");
      this.$store.commit("zIndexIncrement", "photoeditor");
    },
    focusStickies() {
      this.$store.commit("changeActiveWindow", "Stickies");
      this.$store.commit("zIndexIncrement", "stickies");
    },
    focusMail() {
      this.$store.commit("changeActiveWindow", "Mail");
      this.$store.commit("zIndexIncrement", "mail");
    },
    focusBio() {
      this.$store.commit("changeActiveWindow", "Bio");
      this.$store.commit("zIndexIncrement", "bio");
    },
    focusSimulator() {
      this.$store.commit("changeActiveWindow", "Simulator");
      this.$store.commit("zIndexIncrement", "simulator");
    },
  },
  computed: {
    desktopStyle() { return { backgroundImage: `url("${wallpaperImage(this.$store.state.wallpaper, this.$store.getters.theme)}")`, backgroundSize: "cover", backgroundPosition: "center" }; },
    style() {
      return {
        "--fullscreen": window.innerHeight - 30 + "px",
      };
    },
    preloaderImage() {
      if (this.screenWidth <= 600) {
        return require("@/assets/Hello-mobile.webp"); // Mobile image
      } else {
        return require("@/assets/Hello.webp"); // Desktop image
      }
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.screenWidth = window.innerWidth;
    });
    // Wait for the app to load and then fade out the preloader
    this.startupTimers.push(setTimeout(() => {
      const preloader = document.querySelector(".preloader");
      if (preloader) {
        preloader.style.opacity = "0";
        this.startupTimers.push(setTimeout(() => {
          preloader.style.display = "none";
          this.$store.commit("setLoadingBio", !this.$store.getters.isShownBio);
          // Three 850ms bounces end at rest, then a 450ms pause precedes opening.
          this.startupTimers.push(setTimeout(() => {
            this.$store.commit("setLoadingBio", false);
            if (!this.$store.getters.isShownBio) {
              this.$store.commit("toggleShownBio", true);
              this.$nextTick(() => this.focusBio());
            }
          }, 3000));
        }, 1000));
      }
    }, 3000));

    document.getElementById("screen").style.height =
      window.innerHeight - 30 + "px";
    document.addEventListener(
      "keydown",
      function (e) {
        if (
          (window.navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey) &&
          e.keyCode == 83
        ) {
          e.preventDefault();
          if (this.$store.getters.activeWindow == "Stickies") {
            console.log("cmd s up coz stickies on");
          } else {
            console.log("not caught");
          }
        }
      },
      false
    );
    // We listen to the resize event
    window.addEventListener("resize", () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    function resetHeight() {
      // reset the body height to that of the inner browser
      document.body.style.height = window.innerHeight + "px";
      document.documentElement.style.height = window.innerHeight + "px";
    }
    // reset the height whenever the window's resized
    window.addEventListener("resize", resetHeight);
    // called to initially set the height.
    resetHeight();

    this.$store.dispatch("initializeTheme");
  },
  beforeDestroy() {
    this.startupTimers.forEach(clearTimeout);
    this.$store.commit("setLoadingBio", false);
  },
};
</script>

<style>
.iframe-container iframe {
  clip-path: inset(27%);
}
html {
  overflow: hidden;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  flex-direction: column;
  overflow: hidden;
}

.screen {
  width: 100%;
}

.fullscreen {
  left: 0 !important;
  position: relative;
  display: block;
  top: 0 !important;
  right: 0 !important;
}

/* body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

body {
  background-image: url("./assets/light.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

@media (prefers-color-scheme: dark) {
  body {
    background-image: url("./assets/dark.webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
} */

.bar-container {
  width: auto;
  height: 70px;
  background-color: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid rgb(255, 255, 255, 0.2);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.wrapper {
  padding-bottom: 20px;
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.icon {
  width: 45px;
  height: 45px;
  border-radius: 10px;
  background: white;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
}

.icon:hover {
  cursor: pointer;
}

.preloader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  opacity: 1;
  transition: opacity 1s ease-out;
}

/* Center the GIF inside the preloader */
.preloader img {
  width: 50vw; /* Adjust size relative to screen width */
  height: auto; /* Maintain aspect ratio */
}

/* Fade-out effect */
.preloader.fade-out {
  opacity: 0;
  pointer-events: none;
}

:root[data-theme="dark"] .preloader {
    background-color: #000;
  }

@media only screen and (max-width: 600px) {
  .preloader img {
    width: 60vw; /* Make it larger on mobile */
  }
}

/* Launchpad Transition */
.launchpad-fade-enter-active,
.launchpad-fade-leave-active {
  transition: opacity 0.5s ease-in-out, transform 0.4s ease-in-out;
}

/* Fade from invisible */
.launchpad-fade-enter-from {
  opacity: 0;
  transform: scale(1.1); /* Slight zoom-in effect like macOS */
}

.launchpad-fade-enter-to {
  opacity: 1;
  transform: scale(1);
}

/* Start state before fading out */
.launchpad-fade-leave-from {
  opacity: 1;
  transform: scale(1);
}

/* End state when fully faded out */
.launchpad-fade-leave-to {
  opacity: 0;
  transform: scale(1.1);
}

/* Animate scale independently to preserve each window's drag positioning. */
.app-window-enter-active { transition: opacity 180ms ease-out, scale 180ms cubic-bezier(.2,.8,.2,1); transform-origin: center; }
.app-window-enter { opacity: 0; scale: .97; }
.app-window-enter-to { opacity: 1; scale: 1; }
@media (prefers-reduced-motion: reduce) {
  .app-window-enter-active { transition: none; }
  .app-window-enter, .app-window-enter-to { opacity: 1; scale: 1; }
}
</style>
